export enum CAMPAIGN_LABEL_TYPE {
  AFFILIATE = 'Affiliate',
  GIFTING = 'Gifting',
  CASH_PAID = 'Cash-paid',
}

export const EMPTY_LABEL_VALUE = 'No-label' as const;
export const ALL_LABELS_VALUE = '__all_labels__';

export const CampaignLabelOptions = [
  {
    value: EMPTY_LABEL_VALUE,
    label: 'No label',
  },
  {
    value: CAMPAIGN_LABEL_TYPE.AFFILIATE,
    label: 'Affiliate',
  },
  {
    value: CAMPAIGN_LABEL_TYPE.GIFTING,
    label: 'Gifting',
  },
  {
    value: CAMPAIGN_LABEL_TYPE.CASH_PAID,
    label: 'Paid',
  },
];

export const CampaignLabelFilterOptions = [
  {
    value: ALL_LABELS_VALUE,
    label: 'All labels',
  },
  ...CampaignLabelOptions,
];

export enum CAMPAIGN_POSTS_SORT {
  COMMENT_DESC = 'comment_desc',
  LIKE_DESC = 'like_desc',
  POSTED_AT_DESC = 'posted_at_desc',
  RATE_DESC = 'rate_desc',
  SHARED_DESC = 'shared_desc',
  VIEW_DESC = 'view_desc',
}

export enum CampaignStatus {
  SCHEDULED = 'scheduled',
  ACTIVE = 'active',
  ENDED = 'ended',
}

export enum CampaignListSort {
  ENDING_SOON = 'ending_soon',
  START_DATE = 'start_date_desc',
}

export enum CampaignTrackingItemType {
  HANDLE = 'handle',
  POST = 'post',
}
